import { ref } from 'vue'

export const useIntensiveContact = () => {
  const selectCause = ref([
    '飛沫・飛沫核感染',
    '接触感染',
    '不明'
  ])
  const selectPlace = ref([
    '医療機関（病院）',
    '医療機関（診療所）',
    '医療機関（その他医療施設）',
    '学校等',
    '福祉施設（児童）',
    '福祉施設（高齢者）',
    '福祉施設（障害）',
    '福祉施設（その他）',
    '劇場・集会所・展示場',
    'ホテル',
    '運動施設',
    '官公庁',
    '飲食店',
    '事業所',
    '遊興施設',
    '自宅',
    '不明'
  ])
  return {
    selectCause,
    selectPlace
  }
}
